import {
  CustomizeUAPPlacementType as CPT,
} from './ad-placement-type';

export const CustomizePlacementMetaList = {
  [CPT.ImageAdPlacementWithCTA]: {
    placementType: CPT.ImageAdPlacementWithCTA,
    aspectRatio: 1.43,
    previewHeight: 307,
  },
  [CPT.ImageAdPlacementWithImageAsBackground]: {
    placementType: CPT.ImageAdPlacementWithImageAsBackground,
    aspectRatio: 1.78,
    previewHeight: 245,
  },
  [CPT.ImageAdPlacementWithPlayIcon]: {
    placementType: CPT.ImageAdPlacementWithPlayIcon,
    aspectRatio: 1.78,
    previewHeight: 246,
  },
  [CPT.ImageAdPlacementWithRating]: {
    placementType: CPT.ImageAdPlacementWithRating,
    aspectRatio: 1.78,
    previewHeight: 167,
  },
  [CPT.ImageAdWithLogoPlacementNoImage]: {
    placementType: CPT.ImageAdWithLogoPlacementNoImage,
    logoPreviewHeight: 80,
  },
  [CPT.ImageAdWithLogoPlacementWithImage]: {
    placementType: CPT.ImageAdWithLogoPlacementWithImage,
    aspectRatio: 1.45,
    previewHeight: 127,
    logoPreviewHeight: 20,
  },
  [CPT.TextAdPlacement]: {
    placementType: CPT.TextAdPlacement,
  },
};
